var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCatalogIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 18,
    viewBox: "0 0 22.77 17.412",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "book-open-solid",
    d: "M9.867,49.374a.663.663,0,0,0,.885-.613V33.842a.54.54,0,0,0-.2-.435A8.277,8.277,0,0,0,5.693,32a14.545,14.545,0,0,0-4.977.953A1.157,1.157,0,0,0,0,34.048V48.686a.726.726,0,0,0,.953.652,16.96,16.96,0,0,1,4.74-.893A14.265,14.265,0,0,1,9.867,49.374Zm3.036,0a14.265,14.265,0,0,1,4.175-.929,16.96,16.96,0,0,1,4.74.893.725.725,0,0,0,.953-.652V34.048a1.147,1.147,0,0,0-.716-1.091A14.441,14.441,0,0,0,17.078,32a8.277,8.277,0,0,0-4.862,1.407.552.552,0,0,0-.2.435V48.761a.664.664,0,0,0,.885.613Z",
    transform: "translate(0 -32)",
    fill: "#21827f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogIcon);
export default __webpack_public_path__ + "static/media/catalog-icon.3683464813350d2a99956ef87bc1f192.svg";
export { ForwardRef as ReactComponent };